"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TaskBarHandler = {
  currentTaskBar: null,
  register: function register(taskBar) {
    this.currentTaskBar = taskBar;
  },
  unregister: function unregister() {
    this.currentTaskBar = null;
  },
  isShowing: function isShowing() {
    return this.currentTaskBar === null ? false : this.currentTaskBar.isShowing();
  },
  show: function show() {
    var _this = this;
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (this.currentTaskBar === null) {
      return;
    }
    if (newState !== null) {
      this.currentTaskBar.setNewState(newState, function () {
        _this.currentTaskBar.show();
      });
    } else {
      this.currentTaskBar.show();
    }
  },
  hide: function hide() {
    var _this2 = this;
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    if (this.currentTaskBar === null) {
      return;
    }
    this.currentTaskBar.setNewState({}, function () {
      _this2.currentTaskBar.hide(callback);
    });
  }
};
var _default = exports["default"] = TaskBarHandler;